import { Text, VStack } from "@chakra-ui/react"
import type { SkiFeatureDetail } from "../../../hooks/useResortFeatures"

type FeatureInfoTabProps = {
  data: SkiFeatureDetail
}

export default function FeatureInfoTab({ data }: FeatureInfoTabProps) {
  return (
    <VStack align="stretch" gap="3">
      <Text>
        <strong>Name:</strong> {data.name || data.uid}
      </Text>
      <Text>
        <strong>Type:</strong> {data.type}
      </Text>
      <Text>
        <strong>Difficulty:</strong> {data.difficulty || "—"}
      </Text>
      <Text>
        <strong>Convention:</strong> {data.difficulty_convention || "—"}
      </Text>
      <Text>
        <strong>Backcountry:</strong> {data.is_backcountry ? "Yes" : "No"}
      </Text>
    </VStack>
  )
}
